// GENERATED by scripts/gen-web-routes.mjs — regenerate after frontend/app/ changes.
import { createFileRoute } from "@tanstack/react-router"
import Page from "@/app/car-dealer-match/page"
import { usePageHead } from "../../compat/head"

export const Route = createFileRoute("/car-dealer-match/")({
  component: PageComponent,

})

function PageComponent() {
  usePageHead({ title: "Car ↔ Dealer Matching" })
  return <Page />
}
